export default "__VITE_ASSET__D06qe5TS__"